import ReactDOM from 'react-dom/client'
import App from './app'
import { initMockServiceWorker } from '@tino-frontend/mocks'
import { mockDebugAllMocks } from 'modules/mock-debug'
import { REACT_APP_ENV } from 'constants/envs'

if (REACT_APP_ENV !== 'prd') {
  initMockServiceWorker(mockDebugAllMocks)
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <App />
)
